function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getFileExtensionFromFilename } from "../../../../../util/common";
var VerificationResult = {
  CHECK_FAILURE: 'check_failure',
  LOW_QUALITY: 'low_quality',
  NAME_NOT_MATCH: 'name_not_match',
  NOT_CHECKED: 'not_checked',
  SUCCESSFULLY_PASSED: 'successfully_passed',
  IELTS_SCORE_MISMMATCH: 'ielts_score_mismatch',
  STUDENT_INELIGIBLE: 'student_ineligible',
  DOCUMENT_MISMATCH: 'document_mismatch'
};
function getCommonEventData(_ref) {
  var role = _ref.role,
    requirement = _ref.requirement;
  return {
    userRole: role,
    requirementType: requirement.requirement_template_type,
    requirementTemplateId: requirement.requirement_template_id,
    categoryId: requirement.requirement_category
  };
}
export function getFlaggedDocumentEventData(_ref2) {
  var attachment = _ref2.attachment,
    requirement = _ref2.requirement,
    role = _ref2.role;
  return _objectSpread(_objectSpread({}, getCommonEventData({
    role: role,
    requirement: requirement
  })), {}, {
    requirementId: requirement.id,
    filename: attachment.fileName,
    fileType: getFileExtensionFromFilename(attachment.fileName),
    warningReasons: attachment.automatedVerificationResults.map(function (item) {
      var _item$output, _item$output$attribut, _item$output2, _item$output2$attribu, _item$output3, _item$output3$attribu;
      return {
        resultCode: item.resultCode,
        firstNameFound: (_item$output = item.output) === null || _item$output === void 0 ? void 0 : (_item$output$attribut = _item$output.attributes) === null || _item$output$attribut === void 0 ? void 0 : _item$output$attribut.firstNameFound,
        lastNameFound: (_item$output2 = item.output) === null || _item$output2 === void 0 ? void 0 : (_item$output2$attribu = _item$output2.attributes) === null || _item$output2$attribu === void 0 ? void 0 : _item$output2$attribu.lastNameFound,
        nameFound: (_item$output3 = item.output) === null || _item$output3 === void 0 ? void 0 : (_item$output3$attribu = _item$output3.attributes) === null || _item$output3$attribu === void 0 ? void 0 : _item$output3$attribu.nameFound
      };
    })
  });
}
export function getAcceptOrRejectAttachmentEventData(_ref3) {
  var attachment = _ref3.attachment,
    requirement = _ref3.requirement,
    role = _ref3.role,
    oldValue = _ref3.oldValue,
    newValue = _ref3.newValue;
  var event = _objectSpread(_objectSpread({}, getCommonEventData({
    requirement: requirement,
    role: role
  })), {}, {
    requirementInstanceId: requirement.id,
    plagiarismCheckEnabled: hasPlagiarismCheckEnabled(requirement),
    isEarlyAccess: requirement.is_early_access,
    applicationStage: requirement.application_stage,
    flaggedByDocVerification: Boolean(attachment.automatedVerificationResults.length),
    flaggedByDocVerificationReason: attachment.automatedVerificationResults.map(function (item) {
      return item.resultCode;
    }),
    oldValue: oldValue,
    newValue: newValue
  });
  if (event.plagiarismCheckEnabled) {
    event['passedPlagiarism'] = checkDidPassPlagiarism(attachment);
    event['plagiarismOutcome'] = getPlagiarismOutcome(attachment);
  }
  return event;
}
function hasPlagiarismCheckEnabled(req) {
  var _req$validation_rules, _req$validation_rules2;
  return !!(req !== null && req !== void 0 && (_req$validation_rules = req.validation_rules) !== null && _req$validation_rules !== void 0 && (_req$validation_rules2 = _req$validation_rules.plagiarism) !== null && _req$validation_rules2 !== void 0 && _req$validation_rules2.max_plagiarism_score);
}
function getPlagiarismOutcome(attach) {
  var _attach$automatedVeri;
  var completedPlagiarismVerificationResult = (_attach$automatedVeri = attach.automatedVerificationResults) === null || _attach$automatedVeri === void 0 ? void 0 : _attach$automatedVeri.filter(function (avr) {
    return avr.verificationType === 'plagiarism' && avr.resultCode === 'check_complete';
  });
  if (!completedPlagiarismVerificationResult || completedPlagiarismVerificationResult.length !== 1) return [];
  return completedPlagiarismVerificationResult[0].outcome;
}
function checkDidPassPlagiarism(attach) {
  var outcomes = getPlagiarismOutcome(attach);
  if (!outcomes || outcomes.length === 0) return null;
  return outcomes.every(function (o) {
    return o.result === 'passed';
  });
}
export function checkHasWarnings(automatedVerificationResults) {
  return automatedVerificationResults.some(function (result) {
    return VerificationResult.LOW_QUALITY === result.resultCode || VerificationResult.NAME_NOT_MATCH === result.resultCode;
  });
}
export function getPrevAttachmentIndex(_ref4) {
  var attachments = _ref4.attachments,
    currentAttachmentIndex = _ref4.currentAttachmentIndex;
  if (currentAttachmentIndex === 0) {
    return attachments.length - 1;
  }
  return currentAttachmentIndex - 1;
}
export function getNextAttachmentIndex(_ref5) {
  var attachments = _ref5.attachments,
    currentAttachmentIndex = _ref5.currentAttachmentIndex;
  if (currentAttachmentIndex === attachments.length - 1) {
    return 0;
  }
  return currentAttachmentIndex + 1;
}
export function shouldShowDiscrepancyInfo(_ref6) {
  var documentDiscrepancy = _ref6.documentDiscrepancy;
  if (!documentDiscrepancy || documentDiscrepancy.discrepancies.length === 0) {
    return false;
  }
  if (documentDiscrepancy.type === 'passport_discrepancy') {
    return true;
  }
  if (documentDiscrepancy.type === 'ielts_discrepancy') {
    return true;
  }
  return false;
}